import { DEFAULT_TOKEN } from '@/lib/enums'
import { usePersistStore } from '@/store/persist.store'
import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

const useGenerateGuestId = () => {
  const guestId = usePersistStore(state => state.guestId)
  const token = usePersistStore(state => state.token)
  const setGuestId = usePersistStore(state => state.setGuestId)
  const setIsGuestIdActive = usePersistStore(state => state.setIsGuestIdActive)

  useEffect(() => {
    if (token === DEFAULT_TOKEN) {
      setIsGuestIdActive(true)

      if (!guestId) {
        const newGuestId = uuidv4()
        setGuestId(newGuestId)
      }
    }
  }, [token, guestId, setGuestId, setIsGuestIdActive])
}

export default useGenerateGuestId
